// import lightSlider from 'lightslider'
// import lightGallery from 'lightgallery'
//
// require('lg-thumbnail')
// require('lg-video')
let mobile = require('is-mobile')

let lot = {
    initGallery() {
        // let $lotGallery = $('#lot-gallery')
        let $videoGallery = $('#video-gallery')

        const createShowBtn = (link) => `
                     <span id="lg-view">
                       <i class="fas fa-info mr-2 m-1"></i>
                       <a
                           href="${link}"
                         target="_blank"
                         style="color: white"
                       >
                            ${Lang.get('javascript.show_on_youtube')}
                            </a>
                        </span>
                            `;
        // $lotGallery.length && $lotGallery.lightGallery()

        if ($videoGallery.length && mobile({tablet: true})) {
            $videoGallery.on("onAferAppendSlide.lg", (event, index) => {
                let updateSlideInstance = $videoGallery.data('lightGallery');
                if (updateSlideInstance.$outer.find("#lg-view").length) return;

                const link = updateSlideInstance.$items[index].dataset.src;
                const addBtn = createShowBtn(link)

                $(addBtn).insertAfter(updateSlideInstance.$outer.find('.lg-toolbar'))
                console.log(updateSlideInstance.$outer.find('#lg-counter'))
                updateSlideInstance.$outer.find('#lg-counter').css({'position': "absolute", 'top': "50px"})
            }).on("onBeforeSlide.lg", (event, prevIndex, nextIndex) => {
                let updateSlideInstance = $videoGallery.data('lightGallery');

                const link = updateSlideInstance.$items[nextIndex].dataset.src;

                if (updateSlideInstance.$outer.find("#lg-view").length) {
                   updateSlideInstance.$outer.find("#lg-view a").attr('href', link)
                } else {
                    const addBtn = createShowBtn(link)
                    $(addBtn).insertAfter(updateSlideInstance.$outer.find('.lg-toolbar'))
                    updateSlideInstance.$outer.find('#lg-counter').css({'position': "absolute", 'top': "50px"})
                }
            })
        }

        $videoGallery.length &&
            $videoGallery.lightGallery({
                loadYoutubeThumbnail: true,
                youtubeThumbSize: 'default',
                loadVimeoThumbnail: true,
                vimeoThumbSize: 'thumbnail_medium',
                autoplayFirstVideo: true
            })
    },

    initSlider() {
        let windowHeight = $(window).height()
        let windowWidth = $(window).width()
        let thumbPosition
        let sliderHeight
        let verticalS
        let onafterslide

        $('.img-gallery > ul').each(function() {
            thumbPosition = $(this).attr('data-thumbnails')
            let imgChildren = $(this).find('li').length
            if (thumbPosition == 'side' && imgChildren > 1) {
                $(this)
                    .parent('.img-gallery')
                    .addClass('side-thumb')
            }

            // if (windowWidth > 575 && thumbPosition == 'side') {
            //     sliderHeight = $(this)
            //         .find('li:first-child')
            //         .height()
            //     verticalS = true
            // } else {
            //     verticalS = false
            //     sliderHeight = false
            //     onafterslide = false
            // }
            //
            // // fix height with caption and vertical slide
            // onafterslide = function(el) {
            //     let container = el.parents('.lSSlideWrapper')
            //     let sliderWrap = el.parents('.lSSlide')
            //     let activeslide = el.find('li.active')
            //
            //     activeslide.height('auto')
            //     let newheight = activeslide.innerHeight()
            //
            //     activeslide.height(newheight)
            //     container.height(newheight)
            //     sliderWrap.height(newheight)
            // }

            if ($(this).find('li').length > 1) {
                $(this).lightSlider({
                    item: 1,
                    gallery: true,
                    thumbItem: 7,
                    slideMargin: 0,
                    // vertical: verticalS,
                    adaptiveHeight: true,
                    // verticalHeight: sliderHeight,
                    // onAfterSlide: onafterslide,
                    onSliderLoad: function(el) {
                        el.lightGallery({
                            selector: '.lslide',
                            download: false,
                        })
                        // onafterslide(el)
                        // window.addEventListener('resize', function(event) {
                        //     // console.log(event)
                        //     onafterslide(el)
                        // })
                    },
                    controls: false,
                    responsive: [
                        {
                            breakpoint: 1199,
                            settings: {
                                thumbItem: 7,
                            },
                        },
                        {
                            breakpoint: 991,
                            settings: {
                                thumbItem: 7,
                            },
                        },
                        {
                            breakpoint: 767,
                            settings: {
                                thumbItem: 6,
                            },
                        },
                        {
                            breakpoint: 640,
                            settings: {
                                thumbItem: 4,
                            },
                        },
                    ],
                })
            }
        })

        $('.xray-gallery > ul').each(function() {
            if ($(this).find('li').length > 1) {
                let xray = $(this).lightSlider({
                    item: 1,
                    slideMargin: 0,
                    controls: true,
                    pager: false,
                    loop: true,
                    onSliderLoad: function(el) {
                        el.lightGallery({
                            selector: '.lslide',
                            thumbnail: false,
                            download: false,
                            zoom:true
                        })
                        $('body').on('click', '.lg-image', function(e) {
                            if ($('body').hasClass('xray-lg-open')) {
                                $('.lg-close').click()
                            }
                        })
                    },
                })
                xray.on('onBeforeOpen.lg', function() {
                    $('body').addClass('xray-lg-open')
                })
                xray.on('onCloseAfter.lg', function() {
                    $('body').removeClass('xray-lg-open')
                })
            }
        })

        $('.video-gallery-wrap > ul').each(function() {
            if ($(this).find('li').length > 1) {
                $(this).lightSlider({
                    item: 1,
                    gallery: true,
                    thumbItem: 4,
                    slideMargin: 0,
                    adaptiveHeight: true,
                    auto: false,
                    youtubePlayerParams: {
                        modestbranding: 1,
                        showinfo: 0,
                        rel: 0,
                        controls: 0,
                    },
                    vimeoPlayerParams: {
                        byline: 0,
                        portrait: 0,
                    },
                    responsive: [
                        {
                            breakpoint: 991,
                            settings: {
                                thumbItem: 6,
                            },
                        },
                        {
                            breakpoint: 767,
                            settings: {
                                thumbItem: 5,
                            },
                        },
                        {
                            breakpoint: 640,
                            settings: {
                                thumbItem: 3,
                            },
                        },
                    ],
                })
            }
        })

        $('.lot-video-gallery-wrap > ul').each(function() {
            if ($(this).find('li').length > 1) {
                $(this).lightSlider({
                    item: 1,
                    gallery: true,
                    thumbItem: 4,
                    slideMargin: 0,
                    adaptiveHeight: true,
                    auto: false,
                    youtubePlayerParams: {
                        modestbranding: 1,
                        showinfo: 0,
                        rel: 0,
                        controls: 0,
                    },
                    vimeoPlayerParams: {
                        byline: 0,
                        portrait: 0,
                    },
                    responsive: [
                        {
                            breakpoint: 991,
                            settings: {
                                thumbItem: 6,
                            },
                        },
                        {
                            breakpoint: 767,
                            settings: {
                                thumbItem: 5,
                            },
                        },
                        {
                            breakpoint: 640,
                            settings: {
                                thumbItem: 3,
                            },
                        },
                    ],
                })
            }
        })
    },
}

$(() => {
    lot.initGallery()

    lot.initSlider()
})
